import React from 'react'
import DetailView from '../../components/superAdmin/partyInfo/DetailView'

function DetailViewPage() {
  return (
    <div>
        <DetailView />
    </div>
  )
}

export default DetailViewPage